
import { mapState, mapGetters } from 'vuex';
import ReviewScore from '@/enums/ReviewScore';

export default {
  name: 'AppHeaderV2ProductScoreHistogram',
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('productScoreSummary', ['scoresMap']),
    ...mapGetters('productScoreSummary', ['scoredReviewsCount']),
    scoreSummaryLabel() {
      return ReviewScore.values.map(v => ReviewScore.t(v));
    },
    scoreSummary() {
      return Object.values(this.scoresMap).reverse();
    },
    mostSelectedScoreCount() {
      return Math.max(...this.scoreSummary);
    },
    maxCountWidth() {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const bodyFont = window.getComputedStyle(document.body).fontFamily;
      context.font = `12px ${bodyFont}`;
      const maxWidth = context.measureText(this.mostSelectedScoreCount).width;

      return `${Math.ceil(maxWidth)}px`;
    }
  },
  methods: {
    gaugeWidth(scoreCount) {
      const percentage = Math.round(
        (scoreCount / this.scoredReviewsCount) * 100
      );
      return `${percentage}%`;
    },
    isMostSelectedScore(scoreCount) {
      return scoreCount > 0 && scoreCount === this.mostSelectedScoreCount;
    },
    gaugeColor(scoreCount) {
      return this.isMostSelectedScore(scoreCount)
        ? this.reviewSettings.product_score_filter_highlight_color
        : this.reviewSettings.product_score_filter_color;
    }
  }
};
